import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-euc-hematologie",
  "use": "icon-euc-hematologie-usage",
  "viewBox": "0 0 43.52 43.52",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 43.52 43.52\" id=\"icon-euc-hematologie\"><g transform=\"translate(-123.16 -110.56)\"><circle cx=\"21.26\" cy=\"21.26\" r=\"21.26\" transform=\"translate(123.66 111.06)\" fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1\" /><path fill=\"currentColor\" d=\"M155.58,136.11a10.86,10.86,0,0,1-21.72,0c.06-9.3,10.86-18.44,10.86-18.44S155.56,126.64,155.58,136.11Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol